/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WeekModelResponse } from './WeekModelResponse';
import {
    WeekModelResponseFromJSON,
    WeekModelResponseFromJSONTyped,
    WeekModelResponseToJSON,
    WeekModelResponseToJSONTyped,
} from './WeekModelResponse';

/**
 * Response for week model by name
 * @export
 * @interface WeekModelByNameResponse
 */
export interface WeekModelByNameResponse {
    /**
     * Name of week model
     * @type {string}
     * @memberof WeekModelByNameResponse
     */
    name?: string;
    /**
     * WeekModel order
     * @type {number}
     * @memberof WeekModelByNameResponse
     */
    order?: number;
    /**
     * true if this weekmodel is the standard
     * @type {boolean}
     * @memberof WeekModelByNameResponse
     */
    isStandard?: boolean;
    /**
     * 
     * @type {Array<WeekModelResponse>}
     * @memberof WeekModelByNameResponse
     */
    weekModels?: Array<WeekModelResponse>;
}

/**
 * Check if a given object implements the WeekModelByNameResponse interface.
 */
export function instanceOfWeekModelByNameResponse(value: object): value is WeekModelByNameResponse {
    return true;
}

export function WeekModelByNameResponseFromJSON(json: any): WeekModelByNameResponse {
    return WeekModelByNameResponseFromJSONTyped(json, false);
}

export function WeekModelByNameResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WeekModelByNameResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'order': json['order'] == null ? undefined : json['order'],
        'isStandard': json['isStandard'] == null ? undefined : json['isStandard'],
        'weekModels': json['weekModels'] == null ? undefined : ((json['weekModels'] as Array<any>).map(WeekModelResponseFromJSON)),
    };
}

export function WeekModelByNameResponseToJSON(json: any): WeekModelByNameResponse {
    return WeekModelByNameResponseToJSONTyped(json, false);
}

export function WeekModelByNameResponseToJSONTyped(value?: WeekModelByNameResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'order': value['order'],
        'isStandard': value['isStandard'],
        'weekModels': value['weekModels'] == null ? undefined : ((value['weekModels'] as Array<any>).map(WeekModelResponseToJSON)),
    };
}

